import { createAction } from '@reduxjs/toolkit';
import { featureKey } from '../../index';

export const showSnackbar = createAction<string>(featureKey + '/showSnackbar');

export const hideSnackbar = createAction(featureKey + '/hideSnackbar');
